import { ContactDto, CreateContactDto, PatchContactDto } from '../commonTypes/client.types';
import { diContainer } from '../libs/container';
import { ApiBaseClass, IServiceHttp } from './ApiBase';

export namespace ContactApiRequest {
    export interface Create {
        params: {
            clientId: string;
        };
        body: CreateContactDto;
    }

    export interface Update {
        params: {
            clientId: string;
        };
        body: PatchContactDto;
    }

    export interface Delete {
        params: {
            clientId: string;
            id: string;
        };
    }
}

export namespace ContactApiResponse {
    export interface Create {
        body: ContactDto;
    }
}

export class ContactApi {
    constructor(private readonly apiBase: ApiBaseClass) {}

    public create(rest: IServiceHttp<ContactApiRequest.Create, ContactApiResponse.Create>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'cli/v1/contact/:clientId',
        });
    }

    public update(rest: IServiceHttp<ContactApiRequest.Update, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'cli/v1/contact/:clientId',
        });
    }

    public delete(rest: IServiceHttp<ContactApiRequest.Delete, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'DELETE',
            url: 'cli/v1/contact/:clientId/:id',
        });
    }
}

diContainer.bindAsDynamic(ContactApi, c => new ContactApi(c.get(ApiBaseClass)));
